import request from "@/utils/request";

export function getData (url)  {
  return request({
    url: `/data?url=${url}`,
    method: 'GET',
  });
};
export function getTxt ()  {
  return request({
    url: `/MP_verify_yRHkNVWSPBO3qik8.txt`,
    method: 'GET',
  });
};

export function saveData (data)  {
  return request({
    url: `/saveData`,
    method: 'post',
    data:data
  });
};

export function isVip (data) {
  return request({
    url: `/api/isVip?unionId=${data}`,
    method: 'GET'
  })
}
